/* import __COLOCATED_TEMPLATE__ from './sh-tab.hbs'; */
import Component from '@ember/component';

export default Component.extend({
  tagName: 'li',
  classNames: ['tab']
});
